import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReactTable from "react-table";
import Modal from 'react-responsive-modal';
import { STabs, SSelect } from '@avalara/skylab-sdk/react';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import NoData from '../page/NoData';
import SingleCountrySelector from '../selectors/country/SingleCountrySelector.jsx';
import SingleCompanySelector from '../selectors/company/SingleCompanySelector.jsx';
import HighlightOnInAppMessage from '../inAppMessages/HighlightOninAppMessage';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import NumberField from '../fields/number/NumberField';
import FormattedPercentage from '../fields/number/FormattedPercentage';

import Logger, {ALL_MESSAGES, LOG_LEVELS} from '../../utils/logger';
import VAT_CODES_SEARCH_CONTROLLER from '../../controllers/vatCodeSearch';
import LANGUAGE_CONTROLLER from '../../controllers/languages';
import SearchByDetails from './SearchByDetails.jsx';
import SearchByTransactionId from './SearchByTransactionId.jsx';
import SearchByVatBox from './SearchByVatBox.jsx';

const FORM_NAME = 'VAT_CODES_SEARCH_DETAILS_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

const detailsPanelUnsetValues = {
  flow: "",
  documentType: "",
  transactionType: "",
  vatRateType: "",
  goodsType: "",
  supplierType: "",
  taxDueType: "",
  country: "",
  transactionId: ""
};

const alwaysFieldsUnsetValues = {
  vatCode: "",
  companyId: null,
  mainCountry: "",
  mainCountryName: "",
  startDate: "",
  deductibleVAT: "",
  mainVATCode: "1",
  refundVATCode: 0,
  refundType: "",
  extraReports: "",
  withholdingRate: "",
  drcRate: "",
  vatCodeForVATUnit: 0
};

const formUnsetValues = {
  ...alwaysFieldsUnsetValues,
  ...detailsPanelUnsetValues
};

const refundVatCodeOptions = [
  'No', 'Refund for Invoices', 'Refund for Import Documents', 'Simplified Invoice'
];
const salesDRCRateTypes = [
  'Z','L','R','M','S','O','T','U','X','E'
];

const MODAL_CLASSNAMES =  {
  modal: 'modal-max-width-65'
};

class searchByDetailsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: {},
      enableAddButton: false,
      enableViewRatesButton: false,
      isMainCountrySet: false,
      isStartDateSet: false,
      openRatesModal: false,
      openSDRCModal: false,
      activeTab: 'tab-details',
      isAnyFeatureFlagEnabled: this.isAnyFeatureFlagEnabled(),
      areFieldsFilled: !this.isAnyFeatureFlagEnabled(),
      localStartDate: ''
    };
    this.selectRow = this.selectRow.bind(this);
    this.onTabSelection = this.onTabSelection.bind(this);
    this.renderActivePanel = this.renderActivePanel.bind(this);
    this.handleTransactionIdChange = this.handleTransactionIdChange.bind(this);
    this.handleVatBoxChange = this.handleVatBoxChange.bind(this);
  }

  isAnyFeatureFlagEnabled = () => {
    return !!(this.props.featureFlags?.EnableVATCodeSearchByTransactionID || 
      this.props.featureFlags?.EnableVATCodeSearchByVatBoxAndFilingPeriod)
  };

  selectRow(id) {
    const selectedRow = {};
    selectedRow[id] = true;
    this.setState({
      selected: selectedRow,
      enableAddButton: true
    });
    this.props.onFieldChange('transactionId', id);
  }

  onTabSelection(tabDetails) {
    if (!tabDetails?.id || tabDetails.id === this.state.activeTab) {
      return;
    }

    this.props.doClearTransactionIds();
    this.props.doInitialiseForm({
      ...this.props.formData.fieldValues,
      ...detailsPanelUnsetValues
    });
    
    this.setState({
      activeTab: tabDetails.id,
      enableAddButton: false
    });
  }
  
  handleTransactionIdChange(searchText) {
    this.setState({
      selected: {},
      enableAddButton: false
    });
    this.props.getTransactionIdsBySearch(searchText);
  }

  handleVatBoxChange(countryCode, boxValue, filingPeriod, startDate) {
    this.setState({
      selected: {},
      enableAddButton: false
    });
    this.props.getTransactionIdsByVatbox(countryCode, boxValue, filingPeriod, startDate);
  }
  
  renderActivePanel(fieldValues) {
    switch (this.state.activeTab) {
      case 'tab-details':
        return <div id="tabpanel-details" data-testid="tab-details" role="tabpanel" aria-labelledby="tab-details" tabIndex="0" className="mb20">
          <SearchByDetails
            detailsPanelDropdownOptions={this.props.detailsPanelDropdownOptions}
            languageString={this.props.languageString }
            rates={this.props.rates}
            fieldValues={fieldValues}
            onDetailsPanelFieldChange={this.onDetailsPanelFieldChange.bind(this)}
            isMainCountrySet={this.state.isMainCountrySet}
            isStartDateSet={this.state.isStartDateSet}
            onRatesButton={this.onRatesButton.bind(this)}
          />
        </div>
      case 'tab-transactionId':
        return <div id="tabpanel-transactionId" data-testid="tab-transactionId" role="tabpanel" aria-labelledby="tabpanel-transactionId" tabIndex="1" className="mb20">
          <SearchByTransactionId languageString={this.props.languageString } onInputChange={this.handleTransactionIdChange}/>
        </div>;
      case 'tab-vatBox':
        return <div id="tabpanel-vatBox" data-testid="tab-vatBox" role="tabpanel" aria-labelledby="tabpanel-vatBox" tabIndex="2" className="mb20">
          <SearchByVatBox languageString={this.props.languageString } onInputChange={this.handleVatBoxChange} countryCode={fieldValues.mainCountry} startDate={fieldValues.startDate}/>
        </div>;
      default:
        return null;
    }
  }

  areRequiredFieldsFilled = () => {
    //if both FF are set to true then check for condition
    //else old way of displaying
    return Boolean(
        this.props.formData?.fieldValues?.vatCode.trim() && 
        this.props.formData?.fieldValues?.companyId && 
        this.props.formData?.fieldValues?.mainCountry && 
        this.props.formData?.fieldValues?.startDate && 
        this.props.formData?.fieldValues?.deductibleVAT?.trim() !== "" &&
        !isNaN(Number(this.props.formData?.fieldValues?.deductibleVAT.trim()))
  );
};

  render() {
    log.debug('render(): ', this.props);

    const { openRatesModal, openSDRCModal } = this.state;
    let tabItems = [{
      id: "tab-details",
      label: "Details",
      tabPanelId: "tabpanel-details",
      selected: this.state.activeTab === "tab-details"
    }];

    if(this.props.featureFlags?.EnableVATCodeSearchByTransactionID) {
      tabItems.push({
        id: "tab-transactionId",
        label: "Search by Transaction ID",
        tabPanelId: "tabpanel-transactionId",
        selected: this.state.activeTab === "tab-transactionId"
      });
    }

    if(this.props.featureFlags?.EnableVATCodeSearchByVatBoxAndFilingPeriod) {
      tabItems.push({
        id: "tab-vatBox",
        label: "Search by VAT Box",
        tabPanelId: "tabpanel-vatBox",
        selected: this.state.activeTab === "tab-vatBox"
      });
    }

    const fieldValues = this.props.formData && this.props.formData.fieldValues;
    if (!fieldValues) {
      return (<div></div>);
    }
  
    const columns = [
      {
        id: 'rowSelector',
        accessor: '',
        maxWidth: 70,
        Header: <LanguageStringResolver string='vatCodeSearch_Details_Id'/>,
        Cell: ({ original }) => {
          return (
            <span>
              <input
                type="radio"
                className="radio"
                checked={this.state.selected[original.id] === true}
                onChange={() => this.selectRow(original.id)}
              />
              <label className="radio"></label>
            </span>
          );
        }
      },
      {
        accessor: 'id',
        maxWidth: 60,
      }, {
        Header: <LanguageStringResolver string='vatCodeSearch_Details_Description'/>,
        accessor: 'description',
        Cell: ({ original }) => {
          // Remove the underscores in the description returned
          let parsedDescription = original.description.replace(/_/g," ");
          return (<div>{parsedDescription}</div>)
        }
      }];

    const NoDataComponent = props => (
      <NoData
        noDataText="vatCodeSearch_Details_noData"
        {...props}
      />
    );

    return (
      <div>
        <h1><LanguageStringResolver string='vatCodeSearch_pageTitle'/></h1>
        <h3 className="alt mb20"><LanguageStringResolver string='vatCodeSearch_pageSubTitle'/></h3>
        <form>
          <fieldset>
            <ApplicationMessages messageType="applicationError"/>
            {this.state.isAnyFeatureFlagEnabled && (
              <div>
                <label className='mb15'>
                  <LanguageStringResolver string='vatCodeSearch_vatBox_RequiredFields'/>
                </label>
              </div>
            )}
            <div className="min-height-none">
              <s-row>
                <s-col span="6">
                  <HighlightOnInAppMessage
                    scopes={[FORM_NAME]}
                    messageIds={[ALL_MESSAGES.BLANK_VATCODESEARCH_VAT_CODE]}
                  >
                    <label>
                      {this.state.isAnyFeatureFlagEnabled && (<strong style={{ color: 'red' }}>* </strong>)}
                      <LanguageStringResolver string='vatCodeSearch_vatCode_label'/>
                    </label>
                    <input value={fieldValues.vatCode} name='vatCode' onChange={this.onFieldChangeEventHandler.bind(this)}/>
                  </HighlightOnInAppMessage>
                  <HighlightOnInAppMessage
                    scopes={[FORM_NAME]}
                    messageIds={[ALL_MESSAGES.BLANK_VATCODESEARCH_COMPANY_ID]}
                  >
                    <label className="mt10">
                    {this.state.isAnyFeatureFlagEnabled && (<strong style={{ color: 'red' }}>* </strong>)}
                      <LanguageStringResolver string='vatCodeSearch_company_label'/>
                    </label>
                    <SingleCompanySelector
                        companyList={this.props.companies}
                        fieldName={'companyId'}
                        selectionHandler={this.onCompanyFieldChange.bind(this)}
                        selectedCompanyId={fieldValues.companyId}
                        valueCompanyCode={false}
                    />
                  </HighlightOnInAppMessage>
                  <HighlightOnInAppMessage
                    scopes={[FORM_NAME]}
                    messageIds={[ALL_MESSAGES.BLANK_VATCODESEARCH_MAIN_COUNTRY]}
                  >
                    <label className="mt10">
                    {this.state.isAnyFeatureFlagEnabled && (<strong style={{ color: 'red' }}>* </strong>)}
                      <LanguageStringResolver string='vatCodeSearch_mainCountry_label'/>
                    </label>
                    <SingleCountrySelector
                      countryList={this.props.countryList}
                      fieldName={'mainCountry'}
                      disableFilterByLicence={true}
                      selectedCountryCode={fieldValues.mainCountry}
                      selectionHandler={this.onCountryFieldChange.bind(this)}
                    />
                  </HighlightOnInAppMessage>
                  <HighlightOnInAppMessage
                    scopes={[FORM_NAME]}
                    messageIds={[ALL_MESSAGES.BLANK_VATCODESEARCH_START_DATE]}
                  >
                    <label className="mt10">
                    {this.state.isAnyFeatureFlagEnabled && (<strong style={{ color: 'red' }}>* </strong>)}
                      <LanguageStringResolver string='vatCodeSearch_startDate_label'/>
                    </label>
                    <input type="date" data-testid="start-date-input" value={this.state.localStartDate !== undefined ? this.state.localStartDate : (fieldValues.startDate || '')} name='startDate'
                    onChange={this.onStartDateChange.bind(this)}/>
                  </HighlightOnInAppMessage>
                  <HighlightOnInAppMessage
                    scopes={[FORM_NAME]}
                    messageIds={[ALL_MESSAGES.BLANK_VATCODESEARCH_DEDUCTIBLE_VAT]}
                  >
                    <label className="mt10">
                      {this.state.isAnyFeatureFlagEnabled && (<strong style={{ color: 'red' }}>* </strong>)}
                      <LanguageStringResolver string='vatCodeSearch_deductibleVatPercentage_label'/>
                    </label>
                    <NumberField isRational={true} defaultValue={''} value={fieldValues.deductibleVAT}
                                 name='deductibleVAT' onChange={this.onFieldChangeEventHandler.bind(this)}
                    />
                  </HighlightOnInAppMessage>

                  <HighlightOnInAppMessage
                    scopes={[FORM_NAME]}
                    messageIds={[ALL_MESSAGES.BLANK_VATCODESEARCH_MAIN_VAT_CODE]}
                  >
                    <label className="mt10"><LanguageStringResolver string='vatCodeSearch_mainVATCode_label'/></label>
                    <SSelect
                      inputId="vat-code-search-main-vat-code"
                      optionsList={[
                        { 
                          value: '1', 
                          label: LANGUAGE_CONTROLLER.format(this.props.languageString, "vatCodeSearch_mainVATCode_OptionMainVATCode"), 
                          selected: fieldValues.mainVATCode === '1' 
                        },
                        { 
                          value: '2', 
                          label: LANGUAGE_CONTROLLER.format(this.props.languageString, "vatCodeSearch_mainVATCode_OptionSecondLineVATCode"), 
                          selected: fieldValues.mainVATCode === '2' 
                        },
                        { 
                          value: '3', 
                          label: LANGUAGE_CONTROLLER.format(this.props.languageString, "vatCodeSearch_mainVATCode_OptionThirdLineVATCode"), 
                          selected: fieldValues.mainVATCode === '3' 
                        },
                        { 
                          value: '4', 
                          label: LANGUAGE_CONTROLLER.format(this.props.languageString, "vatCodeSearch_mainVATCode_OptionRecargo"), 
                          selected: fieldValues.mainVATCode === '4' 
                        }
                      ]}
                      multiple={false}
                      showSelectionCount={false}
                      onS-select={(e) => {
                        const syntheticEvent = {
                          target: { name: 'mainVATCode', value: e.detail.item.value }
                        };
                        this.onFieldChangeEventHandler(syntheticEvent);
                      }}
                    />
                  </HighlightOnInAppMessage>

                </s-col>
                <s-col span="6">
                  <label><LanguageStringResolver string='vatCodeSearch_refundVATCode_label'/></label>
                  <SSelect
                    inputId="vat-code-search-refund-vat-code"
                    optionsList={refundVatCodeOptions.map((refundCodeOption, key) => ({
                      value: `${key}`,
                      label: refundCodeOption,
                      selected: fieldValues.refundVATCode === key
                    }))}
                    multiple={false}
                    showSelectionCount={false}
                    onS-select={(e) => {
                      const syntheticEvent = {
                        target: { name: 'refundVATCode', value: e.detail.item.value }
                      };
                      this.onFieldChangeEventHandler(syntheticEvent);
                    }}
                  />
                  <label className="mt10"><LanguageStringResolver string='vatCodeSearch_refundType_label'/></label>
                  <input value={fieldValues.refundType} name='refundType' onChange={this.onFieldChangeEventHandler.bind(this)}/>
                  <input className="mt10 checkbox" type="checkbox" name='vatCodeForVATUnit'
                           checked={fieldValues.vatCodeForVATUnit === 1} onChange={this.onFieldChangeEventHandler.bind(this)}
                    />
                  <label className="mt10 checkbox"><LanguageStringResolver string='vatCodeSearch_vatCodeForVatUnit_label'/></label>
                  <div className='clear'></div>

                  <label className="mt10"><LanguageStringResolver string='vatCodeSearch_extraReports_label'/></label>
                  <textarea value={fieldValues.extraReports} name='extraReports' onChange={this.onFieldChangeEventHandler.bind(this)}/>

                  <label className="mt10"><LanguageStringResolver string='vatCodeSearch_withholdingRate_label'/></label>
                  <NumberField decimalPlaces={'2'} isRational={true}
                               value={fieldValues.withholdingRate} name='withholdingRate'
                               onChange={this.onFieldChangeEventHandler.bind(this)}/>

                  <label className="mt10"><LanguageStringResolver string='vatCodeSearch_sDRC_label'/> <a onClick={() => {this.modalHandler('openSDRCModal',true);}}>[?]</a></label>
                  <SSelect
                    inputId="vat-code-search-drc-rate"
                    optionsList={[
                      { 
                        value: '', 
                        label: LANGUAGE_CONTROLLER.format(this.props.languageString, "vatCodeSearch_dropdown_placeholder"), 
                        selected: fieldValues.drcRate === '' 
                      },
                      ...salesDRCRateTypes.map((salesDRCRateType) => ({
                        value: salesDRCRateType,
                        label: salesDRCRateType,
                        selected: fieldValues.drcRate === salesDRCRateType
                      }))
                    ]}
                    multiple={false}
                    showSelectionCount={false}
                    onS-select={(e) => {
                      const syntheticEvent = {
                        target: { name: 'drcRate', value: e.detail.item.value }
                      };
                      this.onFieldChangeEventHandler(syntheticEvent);
                    }}
                  />

                  <Modal open={openSDRCModal} onClose={() => {this.modalHandler('openSDRCModal',false)}}>
                    <h2><LanguageStringResolver string='vatCodeSearch_sDRCAlert_title'/></h2>
                    <div className="VATCode-Details-modal">
                      <LanguageStringResolver string='vatCodeSearch_sDRCAlert_message'/>
                    </div>
                  </Modal>
                </s-col>
              </s-row>
            </div>
          </fieldset>
        </form>
        {this.state.areFieldsFilled && (
          <>
            <br/>
            <div>
              <h3 className="alt"><LanguageStringResolver string='vatCodeSearch_searchDirectory_title'/></h3>
            </div>
            <STabs
              id="demo-tabs"
              data-testid="tabs"
              tabItems={tabItems}
              onS-select={(e) => {
                if (e && e.detail && e.detail.id) {
                  this.onTabSelection(e.detail);
                }
              }}
            />
            <form>
            {this.renderActivePanel(fieldValues)}
              <Modal classNames={MODAL_CLASSNAMES} open={openRatesModal} onClose={() => { this.modalHandler('openRatesModal', false) }}>
                <h2><LanguageStringResolver string='vatCodeSearch_Details_vatRate_modal_title_partA' />{fieldValues.startDate} <LanguageStringResolver string='vatCodeSearch_Details_vatRate_modal_title_partB' /> {fieldValues.mainCountryName} </h2>
                <div className="VATCode-Details-modal">
                  {(this.props.rates) ? (
                    this.props.rates.map((row) => {
                      let tmpValue = row.value;
                      if (row.value !== 'not used') {
                        tmpValue = <FormattedPercentage value={row.value} decimalPlaces={2} />
                      }
                      return (<div><span>{row.type}: {tmpValue} </span></div>)

                    })) : (<div></div>)
                  }
                </div>
              </Modal>
              <fieldset>
                <h3 className="alt mb20"><LanguageStringResolver string='vatCodeSearch_Details_transactions_title'/></h3>
                <ReactTable
                  columns={columns}
                  data={this.props.transactionIds}
                  pageSize={ (this.props.transactionIds) ? this.props.transactionIds.length : 0}
                  minRows={0}
                  NoDataComponent={NoDataComponent}
                  showPagination={false}
                  sortable={false}
                />
                <hr />
                <a className="button primary" disabled={(this.state.enableAddButton ? '' : 'disabled')} onClick={this.onSave.bind(this)}><LanguageStringResolver string='vatCodeSearch_save_button'/></a>
                <a className='button secondary' onClick={this.props.exitAction}><LanguageStringResolver string='vatCodeSearch_cancel_button'/></a>
                <hr/>
              </fieldset>
            </form>
          </>
        )}
      </div>
    )
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount: formUnsetValues',formUnsetValues);
    this.props.getDetailsPanelDropdownOptions();
    this.props.doInitialiseForm(formUnsetValues);
  }

  componentDidMount() {
    const startDate = this.props.formData?.fieldValues?.startDate ?? '';
    this.setState({ localStartDate: startDate });
  }

  componentWillUnmount() {
    log.debug('componentWillUnmount');
    this.props.doDestroyForm();
  }

  componentDidUpdate(prevProps) {
    const prevStartDate = prevProps.formData?.fieldValues?.startDate;
    const currentStartDate = this.props.formData?.fieldValues?.startDate;
    if (prevStartDate !== currentStartDate && this.state.localStartDate !== currentStartDate) {
      this.setState({ localStartDate: currentStartDate ?? '' });
    }
    if(this.state.isAnyFeatureFlagEnabled){
         const prevFields = prevProps.formData?.fieldValues;
         const currentFields = this.props.formData?.fieldValues;   
      if (
        prevFields?.vatCode !== currentFields?.vatCode ||
        prevFields?.companyId !== currentFields?.companyId ||
        prevFields?.mainCountry !== currentFields?.mainCountry ||
        prevFields?.startDate !== currentFields?.startDate ||
        prevFields?.deductibleVAT !== currentFields?.deductibleVAT
      ) {
        const newAreFieldsFilled = this.areRequiredFieldsFilled();
        if (this.state.areFieldsFilled !== newAreFieldsFilled) {
          this.setState({ areFieldsFilled: newAreFieldsFilled });
        }
      }
    }
  }

  modalHandler(modalName, action){
    this.setState({
      [modalName]: action
    });

    switch(modalName) {
      case 'openRatesModal':
        this.props.clearRates();
        break;
      default:
    }
  }

  onStartDateChange(evt) {
    const value = evt.target.value || '';
    this.setState({ localStartDate: value });
    this.onFieldChange('startDate', value);
  }

  onFieldChangeEventHandler(evt, more) {
    let value = evt.target.value;
    let name = evt.target.name;

    if (evt.target.type === 'checkbox') {
      (evt.target.checked) ? (value=1):(value=0)
    }

    this.onFieldChange(name, value);
  }

  onCompanyFieldChange(companyObj){
    const key = Object.keys(companyObj)[0];
    let value = Object.values(companyObj)[0];
    if(isNaN(value)){
      value = undefined;
    }
    this.onFieldChange(key, value);
  }

  onCountryFieldChange(keyValuePair) {
    log.debug('onCountryFieldChange', keyValuePair);
    this.onFieldChange('mainCountry', keyValuePair.mainCountry);
    const country = this.props.countryList.filter(item => item.countryCode === keyValuePair.mainCountry)
    const countryName = country[0]?.countryName ?? '';
    this.onFieldChange('mainCountryName', countryName);

  }

  onFieldChange(field, value) {
    let set = false;
    log.debug('onFieldChange: fieldName: %s value: %s ', field, value);

    this.props.onFieldChange(field, value);

    // Clear any validations previously set on field
    switch (field) {
      case 'vatCode':
        log.clearDictionaryError(ALL_MESSAGES.BLANK_VATCODESEARCH_VAT_CODE);
        break;
      case 'companyId':
        log.clearDictionaryError(ALL_MESSAGES.BLANK_VATCODESEARCH_COMPANY_ID);
        break;
      case 'mainCountry':
        log.clearDictionaryError(ALL_MESSAGES.BLANK_VATCODESEARCH_MAIN_COUNTRY);
        (value) ? set=true : set=false;
        this.setState( { isMainCountrySet: set });
        break;
      case 'startDate':
        (value) ? set=true : set=false;
        this.setState( { isStartDateSet: set });
        log.clearDictionaryError(ALL_MESSAGES.BLANK_VATCODESEARCH_START_DATE);
        break;
      case 'mainVATCode':
        log.clearDictionaryError(ALL_MESSAGES.BLANK_VATCODESEARCH_MAIN_VAT_CODE);
        break;
      case 'deductibleVAT':
        log.clearDictionaryError(ALL_MESSAGES.BLANK_VATCODESEARCH_DEDUCTIBLE_VAT);
        break;

      default:

    }
  }

  onDetailsPanelFieldChange(evt) {
    let value = evt.target.value;
    let field = evt.target.name;

    log.debug('onDetailsPanelFieldChange: fieldName: %s value: %s ', field, value);
    this.props.onFieldChange(field, value).then(()=> {

      this.setState({
        selected: {},
        enableAddButton: false
      });

      let searchCriteria = this.props.formData.fieldValues

      const params = Object.assign({}, {
        flow: searchCriteria.flow,
        documentType: searchCriteria.documentType,
        transactionType: searchCriteria.transactionType,
        vatRateType: searchCriteria.vatRateType,
        typeOfGood: searchCriteria.goodsType,
        supplierType: searchCriteria.supplierType,
        taxDueType: searchCriteria.taxDueType,
        country: searchCriteria.country
      });

      this.props.getTransactionIds(params);

    });

  }

  onRatesButton(countryCode, startDate) {

    this.props.getVATRates(countryCode, startDate)
      .then(() => {
        this.modalHandler('openRatesModal', true);
    })

  }

  validateField(fieldValue, errorCode) {
    return new Promise((resolve, reject) => {
      if ((fieldValue === undefined ) || (fieldValue === '') || (fieldValue === null )) {
        log.setDictionaryMessage(errorCode);
        reject();
      }
      resolve();
    })
  }

  validateMandatoryFields(){
    log.clearAllDictionaryErrors();
    let mandatoryFields = [
      { name: this.props.formData.fieldValues.vatCode, errorCode: ALL_MESSAGES.BLANK_VATCODESEARCH_VAT_CODE },
      { name: this.props.formData.fieldValues.companyId, errorCode: ALL_MESSAGES.BLANK_VATCODESEARCH_COMPANY_ID },
      { name: this.props.formData.fieldValues.mainCountry, errorCode: ALL_MESSAGES.BLANK_VATCODESEARCH_MAIN_COUNTRY },
      { name: this.props.formData.fieldValues.startDate, errorCode: ALL_MESSAGES.BLANK_VATCODESEARCH_START_DATE },
      { name: this.props.formData.fieldValues.mainVATCode, errorCode: ALL_MESSAGES.BLANK_VATCODESEARCH_MAIN_VAT_CODE },
      { name: this.props.formData.fieldValues.deductibleVAT, errorCode: ALL_MESSAGES.BLANK_VATCODESEARCH_DEDUCTIBLE_VAT },
    ];

    return Promise.all(
      mandatoryFields.map(field => this.validateField(field.name, field.errorCode))
    )
  }


  onSave() {
    log.debug('onSave: this.props: ', this.props);

    this.validateMandatoryFields()
      .then(() => {

        let transactionIdKeys = Object.keys(this.state.selected);
        let formFieldValues = this.props.formData.fieldValues;

        // withholdingRate cannot be sent as empty string if not set
        let withholdingRate = parseFloat(formFieldValues.withholdingRate) || 0;

        let body = {
          "vatCode": formFieldValues.vatCode,
          "companyId": formFieldValues.companyId,
          "mainCountry": formFieldValues.mainCountry,
          "startDate": formFieldValues.startDate,
          "deductibleVat": formFieldValues.deductibleVAT,
          "mainVatCode": formFieldValues.mainVATCode,
          "refundVATCode": formFieldValues.refundVATCode,
          "refundType": formFieldValues.refundType,
          "vatCodeForVatUnit": formFieldValues.vatCodeForVATUnit,
          "extraReports": formFieldValues.extraReports,
          "withholdingRate": withholdingRate,
          "drcRate": formFieldValues.drcRate,
          "transactionId": transactionIdKeys[0]
        };

        log.debug("onSave: body: ", body);
        this.props.submitHandler('CREATE_BY_TRANSACTION_ID',body);
      })
  }

}


function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages,
    formData: (state.managedUxForms && state.managedUxForms.forms[FORM_NAME]),
    detailsPanelDropdownOptions: (state.searchByDetailsForm && state.searchByDetailsForm.content),
    rates: (state.searchByDetailsForm && state.searchByDetailsForm.rates),
    transactionIds: (state.searchByDetailsForm && state.searchByDetailsForm.transactionIds),
    failures: (state.searchByDetailsForm && state.searchByDetailsForm.failures),
    countryList : (state.content && state.content.contentData && state.content.contentData.countryList),
    featureFlags: state.featureFlag?.data,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getDetailsPanelDropdownOptions: () => {
      dispatch(VAT_CODES_SEARCH_CONTROLLER.getDropdownOptions());
    },
    getVATRates: (country, effectiveDate) => {
      return new Promise ((resolve, reject) => {
        dispatch(VAT_CODES_SEARCH_CONTROLLER.getVATRates(country, effectiveDate));
        resolve()
      })
    },
    getTransactionIds: (params) => {
      dispatch(VAT_CODES_SEARCH_CONTROLLER.getTransactionIds(params));
    },
    getTransactionIdsBySearch: (id) => {
      dispatch(VAT_CODES_SEARCH_CONTROLLER.getTransactionIdsBySearch(id));
    },
    getTransactionIdsByVatbox: (countryCode, boxNames, filingPeriod, startDate) => {
      dispatch(VAT_CODES_SEARCH_CONTROLLER.getTransactionIdsByVatbox(countryCode, boxNames, filingPeriod, startDate));
    },
    doInitialiseForm: (initialValues) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(FORM_NAME, initialValues));
    },
    doResetForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(FORM_NAME));
    },
    doClearForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(FORM_NAME));
    },
    onFieldChange: (fieldName, value) => {
      return new Promise ((resolve, reject) => {
        dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(FORM_NAME, fieldName, value));
        resolve()
      })
    },
    doFormSubmitted: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(FORM_NAME));
    },
    clearRates: () => {
      dispatch(VAT_CODES_SEARCH_CONTROLLER.clearRates());
    },
    doClearTransactionIds: () => {
      dispatch(VAT_CODES_SEARCH_CONTROLLER.clearTransactionIds());
    },
    doDestroyForm: () => {
      return new Promise((resolve) => {
        dispatch(VAT_CODES_SEARCH_CONTROLLER.clearTransactionIds());
        dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(FORM_NAME));
        resolve()
      })
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(searchByDetailsForm);